// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1W0Gh","title":"styles_title__2xXYP"};